import { SvgComponentProps, Svg } from './svg-component';
export const ArrowDownIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 12} height={size || 14} viewBox="0 0 12 14" fill="none" {...rest}>
        <path
            d="M6 1.375v11.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M.75 7.375 6 12.625l5.25-5.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
